import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { APIEndPoints } from 'src/app/utils/api-endpoint';
import { ApiHttpService } from '../../Service/api.http.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userInfo: any;
  CurrentUserInfo: any;
  UserUpdates!: any[];
  UserCalenderEvents!: any[];
  TodayCalenderEvents!: any[];
  UpcomingCalenderEvents!: any[];
  authUserInfo: any;
  dashBoardInfo: any;
  loginVerified = false;
  isLoggedin$: Subject<boolean> = new Subject();
  isLoggedin: boolean;
  breadCrumbInfo = [];
  completedUserOnboardingTasks;

  familyMemberInvited: boolean;
  profilePicUploaded: boolean;
  emergencyContactAdded: boolean;
  truestedProfessionalInvited: boolean;
  vitalDocuments: boolean;

  constructor(
    private readonly _apiService: ApiHttpService,
    private readonly router: Router,
  ) {}
  setStorage() {
    this.userInfo.spaceUsedinFormat = this.formatBytes();
    this.userInfo.usedPercentage = this.getUsedPercentage();
    this.userInfo.activeFamily = this.userInfo?.allTenants.find(
      (i) => i.isActive,
    )?.name;
  }
  get fullName() {
    return this.userInfo?.firstName + ' ' + (this.userInfo?.lastName || '');
  }
  private formatBytes(spaceUsed = null) {
    const bytes = spaceUsed || this.userInfo.spaceUsed;
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  private getUsedPercentage(spaceUsed = null, totalStorageQuota = 100) {
    const usedbytes = spaceUsed || this.userInfo.spaceUsed;
    const total =
      (spaceUsed
        ? totalStorageQuota
        : this.userInfo.family.totalStorageQuota || totalStorageQuota) *
      1024 *
      1024 *
      1024;
    return (100 * usedbytes) / total;
  }
  GetFamilyUserInfo(userId: any) {
    return this._apiService
      .get(APIEndPoints.User + '/GetUserInfo' + (userId ? '?id=' + userId : ''))
      .pipe();
  }
  GetCommunicationToken() {
    return this._apiService
      .get(APIEndPoints.User + '/GetCommunicationToken')
      .pipe();
  }
  GetUserInfo(userId = null) {
    return this._apiService
      .get(APIEndPoints.User + '/GetUserInfo' + (userId ? '?id=' + userId : ''))
      .pipe(
        tap(({ data }) => {
          if (data) {
            this.userInfo = data;
            if (this.userInfo.family) this.setStorage();
            this.dashBoardInfo = data.dashboards;
            if (
              !data.activeSubscription &&
              !this.router.url.includes('myprofile') &&
              !this.router.url.endsWith('/executor/family') &&
              !this.router.url.includes('authprofessional')
            ) {
              this.router.navigateByUrl('/user/myprofile');
            }
          }
          return data;
        }),
      );
  }

  GetUserUpdates() {
    return this._apiService.get(APIEndPoints.User + '/GetUserUpdates').pipe();
  }

  GetSosInfo() {
    return this._apiService.get(APIEndPoints.Emergency).pipe();
  }
  SwitchTenet(data: any) {
    return this._apiService
      .post(`${APIEndPoints.User}/SwitchTenant`, data)
      .pipe();
  }

  GetConfirmUser() {
    return this._apiService.get(`${APIEndPoints.User}/ConfirmEmail`).pipe();
  }

  GetUserReferrals() {
    return this._apiService.get(`${APIEndPoints.User}/GetUserReferrals`).pipe();
  }

  PostProfilePhoto(file: any) {
    return this._apiService
      .post(`${APIEndPoints.User}/ProfilePhoto`, file)
      .pipe();
  }
  PostBackgroundPhoto(file: any) {
    return this._apiService
      .post(`${APIEndPoints.User}/UpdateBackground`, file)
      .pipe();
  }

  RemoveBackGroundImage() {
    return this._apiService.delete(`${APIEndPoints.User}/Background`).pipe();
  }
  PostCoverPhoto(file: any) {
    return this._apiService
      .post(`${APIEndPoints.User}/CoverPhoto`, file)
      .pipe();
  }

  FmailyMemberLocations() {
    return this._apiService.get(`${APIEndPoints.Location}/family`).pipe();
  }

  GetAddress(lat: any, lng: any, key: any) {
    return this._apiService
      .getExt(`${APIEndPoints.GoogleGeoCode}?latlng=${lat},${lng}&key=${key}`)
      .pipe();
  }

  MoveFiles(file: any) {
    return this._apiService.post(`${APIEndPoints.Files}/MoveFile`, file);
  }
  RenameFile(file: any) {
    return this._apiService.patch(`${APIEndPoints.Files}/RenameFile`, file);
  }
  RenameFamilyNote(file: any) {
    return this._apiService.patch(
      `${APIEndPoints.FamilyNotes}/RenameFamilyNote`,
      file,
    );
  }
  Refer() {
    return this._apiService.get(`${APIEndPoints.User}/refer`);
  }
  ReferPost(req: any) {
    return this._apiService.post(`${APIEndPoints.User}/refer`, req);
  }
  ReferSend(req: any) {
    return this._apiService.post(`${APIEndPoints.User}/refersend`, req);
  }
  UserActivityTracker(req: any) {
    return this._apiService.post(
      `${APIEndPoints.User}/UserActivityTracker`,
      req,
    );
  }
}
